import SearchIcon from "@mui/icons-material/Search";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";

type IProps = {
  searchValue: string;
  handleSearch: any;
  fullWidth?: boolean;
  label?: string;
};

const SearchInput: React.FC<IProps> = ({
  searchValue,
  handleSearch,
  fullWidth = false,
  label = "Search...",
}) => {
  return (
    <FormControl fullWidth>
      <InputLabel>{label}</InputLabel>
      <OutlinedInput
        label={label}
        fullWidth={fullWidth}
        value={searchValue}
        onChange={(e: any) => handleSearch(e.target.value)}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        }
      />
    </FormControl>
  );
};

export default SearchInput;
